import DisclosureBox from './DisclosureBox';

export default DisclosureBox;
